import React from 'react';
import Logo from '../assets/images/ycs_fiscal.png';

const Header = () => <img className="image-fluid" src={Logo} alt="Logo" />;

export default Header;
